import React from 'react';

import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {TableRow} from "../../../core/components/table/table-row";
import {TableCell} from "../../../core/components/table/table-cell";

export class ScoreboardWidgetDividerProps extends BaseProps {
  title: String;
  cells: Array<String>;
}

export const ScoreboardWidgetDivider = (props: ScoreboardWidgetDividerProps) => {
  return (
    <TableRow>
      <TableCell className={'scoreboard-widget-divider-cell'} colSpan={100}>
        <div className={'scoreboard-widget-divider'}/>
      </TableCell>
    </TableRow>
  )
}
